import React from 'react';
import { Pressable } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { observer } from 'mobx-react-lite';
import { GridItemContentCenterV3Props } from './GridItemContentCenterV3.types';
import { styles } from './GridItemContentCenterV3.styles';
import { useResponsiveScale } from 'src/contexts/ResponsiveScaleContext';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { productTestID } from 'src/helpers/testIDs.helper';

export const GridItemContentCenterV3: React.FC<GridItemContentCenterV3Props> = observer(
  ({ product, isHoverSV, onSelect }) => {
    const { responsiveScaleSV } = useResponsiveScale();
    const { isDesktop } = useResponsiveScreen();
    const maxWidthAnimatedStyle = useAnimatedStyle(() => {
      return {
        width: product.preview.userImageArea.width * responsiveScaleSV.value,
        height: product.preview.userImageArea.height * responsiveScaleSV.value,
        top: product.preview.userImageArea.y * responsiveScaleSV.value,
      };
    }, [product.preview.userImageArea, responsiveScaleSV]);

    const hoverStyle = useAnimatedStyle(() => {
      const visible = isHoverSV?.value === product.id && isDesktop;
      return {
        opacity: visible ? 1 : 0,
        backgroundColor: visible ? 'rgba(255, 255, 255, 0.32)' : 'transparent',
      };
    });

    return (
      <Pressable onPress={onSelect} testID={productTestID(product.id)}>
        <Animated.View style={[styles.container, maxWidthAnimatedStyle, hoverStyle]} />
      </Pressable>
    );
  },
);
